import './Root.css';
import Banner from '../assets/banner.svg';
import BannerDark from '../assets/banner-dark.svg';
import Scoreboard from "../components/Scoreboard";
import { CTF_STATUS, ScoreboardContext, ScoreboardContextType } from '../ScoreboardProvider';
import { MoonStarsFill, SunFill } from 'react-bootstrap-icons';
import Timer from "../components/Timer";
import { FC, PropsWithChildren, useContext, useRef, useEffect, useState } from 'react';
import { ThemeContext, ThemeContextType, ThemeEnum } from '../ThemeProvider';

import CINILOGO from "../assets/cini.svg";
import PWNTHEM0LELOGO from '../assets/pwnthem0le.png';
import { STATUS_CODES } from 'http';

const TMP : FC<PropsWithChildren & {b : any}> = ({b})=>{
    return <p style={{color:'white'}}>{b}</p>
}

export function useInterval(callback : () => any, delay : number) {
    const savedCallback = useRef<() => any>();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        if(savedCallback.current != undefined)
            savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
}

const Root = () => {
    const { theme, toggleTheme } = useContext(ThemeContext) as ThemeContextType;
    const { data, refresh } = useContext(ScoreboardContext) as ScoreboardContextType;
    const [maxt2, setmaxt2] = useState(58)
    const count = useRef(0)
    const roundDuration = 60 // in seconds
    const ctfDuration = 12 * 60 * 60 // in seconds

    const cdate = new Date();
    const start_date = data != null && data.ctf_start != "" ? new Date(data.ctf_start) : new Date(2022, 10, 18, 9, 0, 0, 0); // TODO: change near ctf
    const isEnabled = (data?.ctf_status === CTF_STATUS.STARTED) || (cdate.getDay() === start_date.getDay() && cdate.getMonth() === start_date.getMonth()) && cdate >= start_date
    const [starts, setStarts] = useState<{
        t1: number,
        t2: number
    }>({
        t1: (0),
        t2: data?.ctf_status === CTF_STATUS.STARTED ? cdate.getSeconds() : 0
    })
    const t2_loops = Math.ceil((ctfDuration - ctfDuration * starts.t1 / 100)/roundDuration)

    useInterval(() =>{
        let tmp = 0
        if(data?.ctf_status != CTF_STATUS.STARTED) return;
        if(starts.t1 < 0){
            const cdate = new Date();
            const start_date = data != null && data.ctf_start != "" ? new Date(data.ctf_start) : new Date(2022, 10, 18, 9, 0, 0, 0); // TODO: change near ctf
            tmp = data.ctf_round * 60
        }
        setStarts(starts => {
            return {
                t1: starts.t1 >= 0 ? (starts.t1 + .5) % ctfDuration : tmp,
                t2: (starts.t2 + .5) % maxt2
            }
        })
        if(maxt2 === 57 && count.current >= 1){ 
            setmaxt2(60);
            count.current++;
        }
    }, 500)

    return <div className={`root${theme === ThemeEnum.light ? ' root-light' : ''}`}>
        <div className="header">
            <img src={theme === ThemeEnum.light ? BannerDark : Banner} className="banner" alt="banner.svg"/>
        </div> 
        <div className="themebar">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <button onClick={toggleTheme} className={`theme-button ${theme === ThemeEnum.light ? 'theme-button-light' : ''}`}>
                    <div style={{backgroundColor: theme === ThemeEnum.dark ? 'rgba(255, 255, 255, .2)' : 'transparent'}}>
                        <MoonStarsFill color={theme === ThemeEnum.dark ? '#2B2C5A' : 'grey'} />
                    </div>
                    <div style={{backgroundColor: theme === ThemeEnum.light ? 'rgba(0, 0, 0, .2)' : 'transparent'}}>
                        <SunFill color={theme === ThemeEnum.light ? '#F48037' : 'grey'} /> 
                    </div>
                </button>
            </div>
        </div>
        <div className="timings">
            <Timer id="ctf-timer" duration={ctfDuration * 1000} color="#C39347" maxWidth="60%" maxHeight='2rem' loops={1} now={starts.t1} isEnabled={isEnabled} max={data?.total_rounds*60}/>
            <Timer id="round-timer" duration={roundDuration * 1000} color="#6CA97D" maxWidth="50%" maxHeight='1rem' loops={t2_loops} now={starts.t2} isEnabled={isEnabled && t2_loops > 0} max={maxt2}/>
            {
                !isEnabled ? <span className={`endAlert ${theme === ThemeEnum.light ? "endAlert-light" : ""}`}>{data?.ctf_status === CTF_STATUS.FINISHED ? "The CTF is finished" : "The CTF has not started yet"}</span> : null
            }
            {
                data?.ctf_status === CTF_STATUS.STARTED ? <span className={`ctf-round ${theme === ThemeEnum.light ? 'ctf-round-light' : ''}`}>Round {data.ctf_round} of {data.total_rounds}.</span> : null
            }
        </div>
        <div className="main">
            <Scoreboard />
        </div>
        <div className="footer" style={data != null && data.ctf_status !== CTF_STATUS.NOT_STARTED ? {position: "relative"} : {}}>
            <span>Infrastructure provided by:</span>
            <div className="footer-list">
                <a href="https://pwnthem0le.polito.it" ><img src={PWNTHEM0LELOGO} /></a>
                <a href="https://cybersecnatlab.it" ><img src={CINILOGO} /></a>
            </div> 
        </div>
    </div>;
}


export default Root;